(function () {
  function renderChooseCity(state) {
    const section = document.querySelector('.bs-choose-city');
    if (!section) return;

    const nearestWrap = section.querySelector('[data-nearest-cities]');
    const fallbackWrap = section.querySelector('[data-fallback-cities]');
    const nearestGrid = section.querySelector('[data-nearest-cities-grid]');
    const fallbackGrid = section.querySelector('[data-fallback-cities-grid]');
    const allCitiesGrid = section.querySelector('[data-all-cities-grid]');
    
    // Clear all grids
    nearestGrid.innerHTML = fallbackGrid.innerHTML = '';
    
    // Get displayed cities (from mega menu or other components)
    let displayedCities = new Set(window.displayedCities || []);
    
    // Check if highlighting is enabled
    const highlightFirstCard = section.getAttribute('data-highlight-first-card') === 'true';
    
    if (state.nearestCities.length > 0 && state.location?.userGranted) {
      // Render nearest cities
      state.nearestCities.forEach((city, i) => {
        const card = document.createElement('a');
        card.className = 'bs-choose-city__card';
        card.href = city.product || city.external_link || '#';
        if (i === 0 && highlightFirstCard) card.classList.add('bs-choose-city__card--highlight');
        card.innerHTML = `
          <div class="bs-choose-city__card-image">
            ${city.image ? `<img src="${city.image}" alt="${city.cityName}" loading="lazy">` : ''}
            <h4 class="bs-choose-city__card-title">${city.cityName}</h4>
          </div>
        `;
        nearestGrid.appendChild(card);
        
        // Add to displayed cities using name as identifier
        if (city.cityName) displayedCities.add(city.cityName.toLowerCase().trim());
      });
      nearestWrap.style.display = 'block';
      fallbackWrap.style.display = 'none';
    } else {
      // Render fallback cities
      window.CitySelection.createFallbackCards(fallbackGrid, highlightFirstCard);
      
      // Get names of fallback cities that were just created
      const fallbackCards = fallbackGrid.querySelectorAll('.bs-choose-city__card-title');
      fallbackCards.forEach(card => {
        const cityName = card.textContent?.trim();
        if (cityName) displayedCities.add(cityName.toLowerCase());
      });
      
      nearestWrap.style.display = 'none';
      fallbackWrap.style.display = 'block';
    }
    
    // Update global displayed cities
    window.displayedCities = displayedCities;
    
    // Hide cities in all-cities grid that are already displayed
    if (allCitiesGrid) {
      const allCityCards = allCitiesGrid.querySelectorAll('.bs-choose-city__card');
      allCityCards.forEach(card => {
        const cityTitle = card.querySelector('.bs-choose-city__card-title');
        const cityName = cityTitle?.textContent?.trim();
        
        if (cityName && displayedCities.has(cityName.toLowerCase())) {
          card.style.display = 'none';
        } else {
          card.style.display = '';
        }
      });
    }
    
    // Trigger event to notify other components
    document.dispatchEvent(new CustomEvent('citiesUpdated', { 
      detail: { displayedCities: Array.from(displayedCities) }
    }));
  }

  // Function to group cities by country and hide duplicates
  function groupCitiesByCountryAndHideDuplicates() {
    const section = document.querySelector('.bs-choose-city');
    if (!section) return;
    
    const allCitiesGrid = section.querySelector('[data-all-cities-grid]');
    if (!allCitiesGrid) return;
    
    const displayedCities = window.displayedCities || new Set();
    
    // Get all city cards
    const allCityCards = Array.from(allCitiesGrid.querySelectorAll('.bs-choose-city__card'));
    
    // Group cities by country
    const citiesByCountry = {};
    allCityCards.forEach(card => {
      const countryElement = card.querySelector('.bs-choose-city__card-country');
      const country = countryElement?.textContent?.trim() || 'Unknown';
      
      if (!citiesByCountry[country]) {
        citiesByCountry[country] = [];
      }
      citiesByCountry[country].push(card);
    });
    
    // Clear the grid
    allCitiesGrid.innerHTML = '';
    
    // Sort countries alphabetically
    const sortedCountries = Object.keys(citiesByCountry).sort();
    
    // Render cities grouped by country
    sortedCountries.forEach(country => {
      // Create country header
      const countryHeader = document.createElement('div');
      countryHeader.className = 'bs-choose-city__country-header';
      countryHeader.innerHTML = `<h4 class="bs-choose-city__country-title">${country}</h4>`;
      allCitiesGrid.appendChild(countryHeader);
      
      // Create country grid
      const countryGrid = document.createElement('div');
      countryGrid.className = 'bs-choose-city__country-grid';
      
      // Sort cities within country alphabetically
      const sortedCities = citiesByCountry[country].sort((a, b) => {
        const nameA = a.querySelector('.bs-choose-city__card-title')?.textContent?.trim() || '';
        const nameB = b.querySelector('.bs-choose-city__card-title')?.textContent?.trim() || '';
        return nameA.localeCompare(nameB);
      });
      
      // Add cities to country grid (hide if already displayed)
      sortedCities.forEach(card => {
        const cityTitle = card.querySelector('.bs-choose-city__card-title');
        const cityName = cityTitle?.textContent?.trim();
        
        if (cityName && displayedCities.has(cityName.toLowerCase())) {
          card.style.display = 'none';
        } else {
          card.style.display = '';
        }
        
        countryGrid.appendChild(card);
      });
      
      allCitiesGrid.appendChild(countryGrid);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.CitySelectionManager.onUpdate(renderChooseCity);
    
    // Group cities by country and hide duplicates when the page loads
    setTimeout(groupCitiesByCountryAndHideDuplicates, 100);
  });
  
  // Listen for updates from other components
  document.addEventListener('citiesUpdated', groupCitiesByCountryAndHideDuplicates);
})();
